import BaseItem from './base_item';

export default class Potato extends BaseItem {
    constructor(x, y) {
        super(x, y, "items", "potato.png");
    }

    //this is width/height of collision box (attached to bottom)
    static get width() { return 15; }
    static get height() { return 8; }

    static get mass() { return 1; }
    static get electronic() { return false; }


    static get type() { return 'potato' }
    static get label() { return 'potato' }
    static get description() {
        return `Tasty delicious potatoes! Starving spaceman choice #1`}
}


// WEBPACK FOOTER //
// ./src/objects/items/potato.js